module.exports = __webpack_public_path__ + "img/alert.2d7b8a19.svg";